<template>
	<div class="pet-weather">
		<!-- ローディング -->
		<transition name="fade">
			<div v-if="isLoading" class="pet-weather__loading">
				<webview-redraw-progress />
			</div>
		</transition>
		<!-- /ローディング -->

		<!-- おさんぽ指数 -->
		<section class="pet-weather__inner">
			<!-- タイトル -->
			<h2 class="pet-weather__title">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M8.89157 8.4905C10.4562 8.4905 11.7245 7.21572 11.7245 5.6432C11.7245 4.07068 10.4562 2.7959 8.89157 2.7959C7.32696 2.7959 6.05859 4.07068 6.05859 5.6432C6.05859 7.21572 7.32696 8.4905 8.89157 8.4905Z" fill="#4C4C4C"/>
					<path d="M15.4326 8.4905C16.9972 8.4905 18.2656 7.21572 18.2656 5.6432C18.2656 4.07068 16.9972 2.7959 15.4326 2.7959C13.868 2.7959 12.5996 4.07068 12.5996 5.6432C12.5996 7.21572 13.868 8.4905 15.4326 8.4905Z" fill="#4C4C4C"/>
					<path d="M4.04287 13.0153C5.52924 13.0153 6.73418 11.8043 6.73418 10.3104C6.73418 8.8165 5.52924 7.60547 4.04287 7.60547C2.5565 7.60547 1.35156 8.8165 1.35156 10.3104C1.35156 11.8043 2.5565 13.0153 4.04287 13.0153Z" fill="#4C4C4C"/>
					<path d="M19.9374 13.0153C21.4238 13.0153 22.6287 11.8043 22.6287 10.3104C22.6287 8.8165 21.4238 7.60547 19.9374 7.60547C18.451 7.60547 17.2461 8.8165 17.2461 10.3104C17.2461 11.8043 18.451 13.0153 19.9374 13.0153Z" fill="#4C4C4C"/>
					<path d="M17.9323 14.4028C16.1351 13.5951 15.3129 12.3377 15.0869 12.0156C14.6155 11.3433 13.4901 10.2422 11.9939 10.2422C10.4977 10.2422 9.37206 11.3433 8.90092 12.0156C8.67496 12.3377 7.85272 13.5954 6.05551 14.4028C4.80985 14.9626 3.75685 16.451 3.81056 17.9476C3.87808 19.8275 5.71881 21.197 8.42289 21.197H15.5649C18.269 21.197 20.1097 19.8275 20.1773 17.9476C20.231 16.451 19.178 14.9626 17.9323 14.4028Z" fill="#4C4C4C"/>
				</svg>
				<span>おさんぽ注意指数</span>
			</h2>
			<!-- /タイトル -->
			<section class="pet-weather__index">
				<!-- 見出し -->
				<h3 class="pet-weather__index--head">
					<p class="is-time">
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
							<path d="M5.87784 11.1628C4.59223 11.1337 3.37059 10.5961 2.48061 9.66789C1.59063 8.73967 1.1049 7.49651 1.12984 6.21081C1.10463 4.92494 1.59025 3.68152 2.48025 2.75309C3.37026 1.82466 4.59205 1.28695 5.87784 1.25781C7.16381 1.28668 8.38585 1.82428 9.27608 2.75274C10.1663 3.68121 10.6521 4.92477 10.6268 6.21081C10.6515 7.49661 10.1656 8.73976 9.27542 9.66795C8.38528 10.5961 7.16354 11.1337 5.87784 11.1628ZM5.87784 2.44581C4.90711 2.47485 3.98744 2.88736 3.3202 3.59302C2.65297 4.29868 2.29254 5.23998 2.31784 6.21081C2.29254 7.18165 2.65297 8.12295 3.3202 8.82861C3.98744 9.53427 4.90711 9.94678 5.87784 9.97581C6.84866 9.94678 7.76843 9.5343 8.43582 8.82867C9.10322 8.12304 9.46387 7.18174 9.43884 6.21081C9.46414 5.23981 9.10357 4.29836 8.43612 3.59267C7.76867 2.88698 6.84875 2.47459 5.87784 2.44581Z" fill="#4C4C4C"/>
							<path d="M8.68402 6.72H5.66602V3.125H6.54602V5.84H8.68402V6.72Z" fill="#4C4C4C"/>
						</svg>
						<span>時間</span>
					</p>
					<p class="is-index">
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
							<path d="M4.44578 4.24574C5.22809 4.24574 5.86227 3.60835 5.86227 2.82209C5.86227 2.03583 5.22809 1.39844 4.44578 1.39844C3.66348 1.39844 3.0293 2.03583 3.0293 2.82209C3.0293 3.60835 3.66348 4.24574 4.44578 4.24574Z" fill="#4C4C4C"/>
							<path d="M7.71727 4.24574C8.49957 4.24574 9.13376 3.60835 9.13376 2.82209C9.13376 2.03583 8.49957 1.39844 7.71727 1.39844C6.93496 1.39844 6.30078 2.03583 6.30078 2.82209C6.30078 3.60835 6.93496 4.24574 7.71727 4.24574Z" fill="#4C4C4C"/>
							<path d="M2.02144 6.50863C2.76462 6.50863 3.36709 5.90312 3.36709 5.15617C3.36709 4.40923 2.76462 3.80371 2.02144 3.80371C1.27825 3.80371 0.675781 4.40923 0.675781 5.15617C0.675781 5.90312 1.27825 6.50863 2.02144 6.50863Z" fill="#4C4C4C"/>
							<path d="M9.97065 6.50863C10.7138 6.50863 11.3163 5.90312 11.3163 5.15617C11.3163 4.40923 10.7138 3.80371 9.97065 3.80371C9.22747 3.80371 8.625 4.40923 8.625 5.15617C8.625 5.90312 9.22747 6.50863 9.97065 6.50863Z" fill="#4C4C4C"/>
							<path d="M8.96535 7.20272C8.0666 6.79881 7.65541 6.17001 7.54241 6.00893C7.30666 5.67274 6.7439 5.12207 5.99567 5.12207C5.24743 5.12207 4.68453 5.67274 4.44892 6.00893C4.33592 6.17001 3.92474 6.79896 3.02598 7.20272C2.40305 7.48266 1.87647 8.22698 1.90333 8.97539C1.93709 9.91549 2.85761 10.6004 4.20987 10.6004H7.78147C9.13373 10.6004 10.0542 9.91549 10.088 8.97539C10.1149 8.22698 9.58828 7.48266 8.96535 7.20272Z" fill="#4C4C4C"/>
						</svg>
						<span>注意指数</span>
					</p>
					<p class="is-road-surface-temperature">
						<svg width="13" height="12" viewBox="0 0 13 12" fill="none">
							<g clip-path="url(#clip0_2184_63008)">
								<path d="M9.11664 5.49849V3.25881C9.12898 2.64439 8.8981 2.04998 8.47427 1.60497C8.05044 1.15997 7.46797 0.900411 6.85368 0.882812C6.23939 0.900411 5.65692 1.15997 5.23309 1.60497C4.80926 2.04998 4.57838 2.64439 4.59072 3.25881V5.54409C3.93121 6.25455 3.57723 7.19567 3.60504 8.16465C3.59914 8.62366 3.68371 9.07933 3.85392 9.50566C4.02414 9.93198 4.27666 10.3206 4.59707 10.6493C4.91748 10.978 5.29951 11.2404 5.72133 11.4215C6.14315 11.6026 6.59651 11.6988 7.05552 11.7047C8.89272 11.7047 10.3493 10.1363 10.3493 8.16465C10.3467 7.65789 10.2353 7.1576 10.0227 6.69759C9.81008 6.23759 9.50118 5.82859 9.11688 5.49825L9.11664 5.49849Z" fill="#4C4C4C"/>
								<path d="M8.26624 5.94666V3.25866C8.27228 3.06844 8.2404 2.87893 8.17246 2.70116C8.10451 2.52339 8.00186 2.36093 7.87049 2.22324C7.73912 2.08554 7.58165 1.97538 7.40727 1.89916C7.23289 1.82294 7.04509 1.78219 6.8548 1.7793C6.66453 1.78216 6.47674 1.82287 6.30236 1.89905C6.12799 1.97522 5.97052 2.08534 5.83913 2.22298C5.70774 2.36063 5.60506 2.52305 5.53707 2.70077C5.46908 2.8785 5.43714 3.06798 5.44312 3.25818V5.97018C5.11961 6.2343 4.8621 6.57016 4.69101 6.95114C4.51991 7.33211 4.43994 7.74771 4.45744 8.16498C4.4574 8.85848 4.72983 9.52424 5.21602 10.0188C5.70221 10.5133 6.36323 10.797 7.05664 10.8088C8.42296 10.8088 9.47608 9.64362 9.47608 8.16498C9.47561 7.72362 9.36465 7.2894 9.15332 6.90193C8.942 6.51445 8.63703 6.18605 8.26624 5.94666Z" fill="#F0F0F0"/>
								<path d="M7.61648 6.64144L7.37 6.50704V4.58008H6.33944V6.50704L6.11528 6.64144C5.64488 6.91024 5.35352 7.4704 5.35352 8.16496C5.35889 8.61109 5.53687 9.0378 5.85012 9.35552C6.16336 9.67324 6.5875 9.85726 7.03352 9.86896C7.90736 9.86896 8.55704 9.12952 8.55704 8.16496C8.55217 7.84975 8.46213 7.54172 8.29647 7.27352C8.1308 7.00531 7.89568 6.7869 7.616 6.64144H7.61648Z" fill="#4C4C4C"/>
							</g>
								<defs>
								<clipPath id="clip0_2184_63008">
									<rect width="12" height="12" fill="white" transform="translate(0.833984)"/>
								</clipPath>
							</defs>
						</svg>
						<span>路面温度</span>
					</p>
					<p class="is-precipitation">
						<svg width="13" height="12" viewBox="0 0 13 12" fill="none">
							<g clip-path="url(#clip0_2184_63017)">
								<path d="M7.96145 4.43405C7.98742 4.63054 7.97113 4.83032 7.91367 5.02001C7.8562 5.2097 7.75889 5.38493 7.62825 5.53398C7.4976 5.68303 7.33663 5.80246 7.1561 5.88428C6.97557 5.9661 6.77966 6.00843 6.58145 6.00843C6.38325 6.00843 6.18733 5.9661 6.00681 5.88428C5.82628 5.80246 5.66531 5.68303 5.53466 5.53398C5.40401 5.38493 5.3067 5.2097 5.24924 5.02001C5.19178 4.83032 5.17548 4.63054 5.20145 4.43405C5.20145 3.64205 6.59345 0.498047 6.59345 0.498047C6.59345 0.498047 7.96145 3.61805 7.96145 4.43405Z" fill="#4C4C4C"/>
								<path d="M5.08059 10.2182C5.10656 10.4147 5.09027 10.6145 5.03281 10.8042C4.97534 10.9939 4.87803 11.1691 4.74739 11.3182C4.61674 11.4672 4.45577 11.5866 4.27524 11.6685C4.09472 11.7503 3.8988 11.7926 3.70059 11.7926C3.50239 11.7926 3.30647 11.7503 3.12595 11.6685C2.94542 11.5866 2.78445 11.4672 2.6538 11.3182C2.52315 11.1691 2.42584 10.9939 2.36838 10.8042C2.31092 10.6145 2.29462 10.4147 2.32059 10.2182C2.32059 9.42623 3.71259 6.28223 3.71259 6.28223C3.71259 6.28223 5.08059 9.40223 5.08059 10.2182Z" fill="#4C4C4C"/>
								<path d="M11.0806 8.70651C11.1066 8.903 11.0903 9.10278 11.0328 9.29247C10.9753 9.48216 10.878 9.65739 10.7474 9.80644C10.6167 9.95549 10.4558 10.0749 10.2752 10.1567C10.0947 10.2386 9.8988 10.2809 9.70059 10.2809C9.50239 10.2809 9.30647 10.2386 9.12595 10.1567C8.94542 10.0749 8.78445 9.95549 8.6538 9.80644C8.52315 9.65739 8.42584 9.48216 8.36838 9.29247C8.31092 9.10278 8.29462 8.903 8.32059 8.70651C8.32059 7.91451 9.71259 4.77051 9.71259 4.77051C9.71259 4.77051 11.0806 7.89051 11.0806 8.70651Z" fill="#4C4C4C"/>
							</g>
							<defs>
								<clipPath id="clip0_2184_63017">
									<rect width="12" height="12" fill="white" transform="translate(0.5)"/>
								</clipPath>
							</defs>
						</svg>
						<span>降水量</span>
					</p>
					<p class="is-wind">
						<svg width="13" height="12" viewBox="0 0 13 12" fill="none">
							<g clip-path="url(#clip0_2184_63025)">
								<path d="M11.0243 5.77051H9.13672V6.95035H11.0243V5.77051Z" fill="#4C4C4C"/>
								<path d="M6.66006 11.9525C5.19606 11.9525 3.97015 10.7727 3.73423 9.28611C3.02464 9.14259 2.38795 8.75457 1.93514 8.1897C1.48234 7.62483 1.24215 6.91896 1.25646 6.19515C1.245 5.46745 1.49266 4.75938 1.95517 4.19746C2.41769 3.63553 3.06493 3.25637 3.78126 3.12771C3.91254 2.44903 4.27802 1.83802 4.81388 1.40135C5.34974 0.964671 6.02195 0.73007 6.71315 0.738501C7.40436 0.746932 8.07065 0.997859 8.5957 1.44748C9.12076 1.89709 9.47122 2.51683 9.5859 3.19851H11.0259V4.61451H8.42958V3.85899C8.42958 2.74995 7.67455 1.92411 6.65983 1.92411C6.18831 1.9303 5.73819 2.12196 5.40696 2.45759C5.07572 2.79323 4.89002 3.24583 4.89006 3.71739V4.33083H4.18206C3.68774 4.3419 3.21778 4.54767 2.87435 4.9034C2.53093 5.25912 2.34182 5.73603 2.34815 6.23044C2.35447 6.72485 2.55572 7.19677 2.90813 7.54359C3.26054 7.89041 3.73562 8.08409 4.23006 8.08251H4.93806V8.79051C4.93806 9.82875 5.74038 10.7019 6.70782 10.7019C7.67526 10.7019 8.47758 9.73443 8.47758 8.86131V8.13003H11.0725V9.54603H9.60846C9.27918 10.7256 8.05206 11.9525 6.66006 11.9525Z" fill="#4C4C4C"/>
							</g>
							<defs>
								<clipPath id="clip0_2184_63025">
									<rect width="12" height="12" fill="white" transform="translate(0.167969)"/>
								</clipPath>
							</defs>
						</svg>
						<span>風</span>
					</p>
				</h3>
				<!-- /見出し -->
				<!-- リスト -->
				<div class="pet-weather__index--inner">
					<section v-for="(item, index) in weatherData" :key="`pet-walking-index-date${index}`">
						<h4 class="pet-weather__index--date">{{ item[0].date }}</h4>
						<ul class="pet-weather__index--list">
							<li v-for="(data, indexTime) in item" :key="`pet-walking-index-time${indexTime}`">
								<div v-if="data.walking_index !== 'walking_index_level0'" class="pet-weather__index--item">
									<p class="is-time">
										<span>{{ data.time }}</span>
									</p>
									<p class="is-index">
										<i :class="`sprite ${data.walking_index}`" />
									</p>
									<div class="pet-weather__index--item-inner">
										<p class="is-road-surface-temperature">
											<i :class="`sprite ${data.road_temp_prediction_level}`" />
											<span>{{ data.road_temp_prediction }}℃</span>
										</p>
										<p class="is-precipitation">
											<i :class="`sprite ${data.rain_fall_level}`" />
											<span>{{ data.rain_fall }}mm</span>
										</p>
										<p class="is-wind">
											<i :class="`sprite ${data.wind_velocity_level}`" />
											<span>{{ data.wind_velocity }}m/s</span>
										</p>
										<p
											:class="[
												'is-comment',
												{ 'is-open': data.is_walking_comment_open }
											]"
											@click="onToggleComment(index, indexTime, data, 'walking')"
										>
											<span>{{ data.walking_comment }}</span>
											<svg class="close" width="18" height="12" viewBox="0 0 18 12" fill="none">
												<rect x="0.726562" y="0.5" width="17" height="11" rx="4" fill="#999999"/>
												<path d="M5.77734 7.72461L9.21822 4.27447L12.6776 7.72461" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
											</svg>
											<svg class="open" width="17" height="11" viewBox="0 0 17 11" fill="none">
												<rect width="17" height="11" rx="4" fill="#999999"/>
												<path d="M11.9512 3.77441L8.51029 7.22456L5.05089 3.77441" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
											</svg>
										</p>
									</div>
								</div>
								<p v-else class="pet-weather__nodata">データが取得できません</p>
								<p v-if="arraySolarTime.length > 0 && arraySolarTime[index].sunrise_key === `${item[0].date}_${data.time}`" class="pet-weather__solartime">
									<span class="is-time">{{ arraySolarTime[index].sunrise }}</span>
									<span class="is-text"><img src="~@/assets/img/pet/icon_sunrise.png">日の出</span>
								</p>
								<p v-if="arraySolarTime.length > 0 && arraySolarTime[index].sunset_key === `${item[0].date}_${data.time}`" class="pet-weather__solartime">
									<span class="is-time">{{ arraySolarTime[index].sunset }}</span>
									<span class="is-text"><img src="~@/assets/img/pet/icon_sunset.png">日の入</span>
								</p>
							</li>
						</ul>
					</section>
				</div>
				<!-- /リスト -->
			</section>
		</section>
		<!-- /おさんぽ指数-->

		<!-- 熱中症指数 -->
		<section class="pet-weather__inner">
			<!-- タイトル -->
			<h2 class="pet-weather__title">
				<svg width="24" height="25" viewBox="0 0 24 25" fill="none">
					<g clip-path="url(#clip0_2239_245676)">
						<path d="M13.7534 4.02303L15.1982 2.58363C15.6165 2.16811 15.6192 1.48914 15.201 1.0709C14.7827 0.65266 14.1065 0.649944 13.6882 1.06819L11.0321 3.71071C10.9941 3.74873 10.9615 3.79219 10.9316 3.83564C11.2087 3.80848 11.4884 3.7949 11.7708 3.7949C12.4525 3.7949 13.1152 3.87638 13.7534 4.02575V4.02303Z" fill="white"/>
						<path d="M14.4452 0.755859C14.1736 0.755859 13.8993 0.859062 13.6902 1.06818L11.0341 3.71071C10.9961 3.74873 10.9635 3.79218 10.9336 3.83564C11.2106 3.80848 11.4903 3.7949 11.7728 3.7949C12.4545 3.7949 13.1171 3.87637 13.7554 4.02575L15.2002 2.58634C15.6184 2.17082 15.6212 1.49186 15.2029 1.07361C14.9938 0.861778 14.7195 0.755859 14.4452 0.755859Z" fill="#4C4C4C"/>
						<path d="M9.83856 20.9619L8.3367 22.4719C7.92117 22.8902 7.92117 23.5691 8.33941 23.9847C8.54853 24.1911 8.82012 24.297 9.09442 24.297C9.36872 24.297 9.64302 24.1911 9.85214 23.9819L12.4947 21.3258C12.5517 21.2688 12.6006 21.2036 12.6413 21.1384C12.3534 21.1683 12.0628 21.1819 11.7695 21.1819C11.1042 21.1819 10.4578 21.1059 9.83585 20.9619H9.83856Z" fill="white"/>
						<path d="M9.83856 20.9619L8.3367 22.4719C7.92117 22.8902 7.92117 23.5691 8.33941 23.9847C8.54853 24.1911 8.82012 24.297 9.09442 24.297C9.36872 24.297 9.64302 24.1911 9.85214 23.9819L12.4947 21.3258C12.5517 21.2688 12.6006 21.2036 12.6413 21.1384C12.3534 21.1683 12.0628 21.1819 11.7695 21.1819C11.1042 21.1819 10.4578 21.1059 9.83585 20.9619H9.83856Z" fill="#4C4C4C"/>
						<path d="M21.2276 7.92049C21.8169 7.92049 22.2949 7.4425 22.2976 6.85316C22.2976 6.2611 21.8223 5.78311 21.2303 5.78039L17.4824 5.76953H17.4797C17.4199 5.76953 17.3656 5.77768 17.3086 5.78583C18.0364 6.38875 18.6638 7.10845 19.1635 7.91234L21.2249 7.91777H21.2276V7.92049Z" fill="white"/>
						<path d="M17.4844 5.77225H17.4816C17.4219 5.77225 17.3676 5.7804 17.3105 5.78854C18.0384 6.39146 18.6658 7.11116 19.1655 7.91506L21.2268 7.92049H21.2295C21.8189 7.92049 22.2969 7.4425 22.2996 6.85316C22.2996 6.2611 21.8243 5.78311 21.2322 5.78039L17.4844 5.76953V5.77225Z" fill="#4C4C4C"/>
						<path d="M4.42323 17.124L2.30758 17.1295C1.71552 17.1295 1.23753 17.6102 1.24025 18.2022C1.24025 18.7916 1.72095 19.2695 2.31029 19.2695H2.31301L6.06088 19.2587C6.14236 19.2587 6.2184 19.2478 6.29445 19.2315C5.56117 18.6368 4.92837 17.9252 4.42323 17.124Z" fill="white"/>
						<path d="M4.42323 17.124L2.30758 17.1295C1.71552 17.1295 1.23753 17.6102 1.24025 18.2022C1.24025 18.7916 1.72095 19.2695 2.31029 19.2695H2.31301L6.06088 19.2587C6.14236 19.2587 6.2184 19.2478 6.29445 19.2315C5.56117 18.6368 4.92837 17.9252 4.42323 17.124Z" fill="#4C4C4C"/>
						<path d="M23.2292 14.4464L20.5867 11.7903C20.5378 11.7414 20.4835 11.698 20.4264 11.6572C20.4536 11.9288 20.4672 12.2058 20.4672 12.4856C20.4672 13.1672 20.3857 13.8326 20.2363 14.4709L21.7138 15.9564C21.9229 16.1655 22.1972 16.2715 22.4715 16.2715C22.7458 16.2715 23.0174 16.1683 23.2265 15.9591C23.6447 15.5436 23.6474 14.8646 23.2292 14.4464Z" fill="white"/>
						<path d="M20.4264 11.6572C20.4536 11.9288 20.4672 12.2058 20.4672 12.4856C20.4672 13.1672 20.3857 13.8326 20.2363 14.4709L21.7138 15.9564C21.9229 16.1655 22.1972 16.2715 22.4715 16.2715C22.7458 16.2715 23.0174 16.1683 23.2265 15.9591C23.6447 15.5436 23.6474 14.8646 23.2292 14.4464L20.5867 11.7903C20.5378 11.7414 20.4835 11.698 20.4264 11.6572Z" fill="#4C4C4C"/>
						<path d="M3.12298 13.3764C3.0931 13.0831 3.07681 12.7871 3.07681 12.4856C3.07681 11.823 3.15285 11.1766 3.29408 10.5574L1.82208 9.09353C1.40384 8.67801 0.724878 8.67801 0.309352 9.09625C-0.106173 9.51449 -0.106173 10.1935 0.312068 10.609L2.96817 13.2515C3.01434 13.2977 3.06594 13.3384 3.12026 13.3737L3.12298 13.3764Z" fill="white"/>
						<path d="M1.06903 8.78104C0.794727 8.78104 0.520426 8.88695 0.311305 9.09607C-0.10422 9.51432 -0.10422 10.1933 0.314021 10.6088L2.97013 13.2513C3.0163 13.2975 3.0679 13.3382 3.12221 13.3735C3.09234 13.0802 3.07604 12.7842 3.07604 12.4827C3.07604 11.8201 3.15209 11.1737 3.29331 10.5545L1.82132 9.09064C1.6122 8.88424 1.34061 8.77832 1.06631 8.77832L1.06903 8.78104Z" fill="#4C4C4C"/>
						<path d="M16.3785 19.8533L16.373 21.9798C16.373 22.5719 16.8483 23.0499 17.4404 23.0526H17.4431C18.0324 23.0526 18.5104 22.5746 18.5131 21.9853L18.524 18.2374C18.524 18.1532 18.5131 18.0717 18.4941 17.9902C17.8966 18.7181 17.1824 19.3482 16.3812 19.8506L16.3785 19.8533Z" fill="white"/>
						<path d="M18.4953 17.993C17.8978 18.7208 17.1836 19.3509 16.3824 19.8533L16.377 21.9798C16.377 22.5719 16.8522 23.0499 17.4443 23.0526H17.447C18.0363 23.0526 18.5143 22.5746 18.517 21.9853L18.5279 18.2374C18.5279 18.1532 18.517 18.0717 18.498 17.9902L18.4953 17.993Z" fill="#4C4C4C"/>
						<path d="M5.05061 6.97816C5.65081 6.24759 6.36508 5.61752 7.16897 5.11508L7.16354 3.06733C7.16354 2.47799 6.68284 2 6.0935 2H6.09078C5.49872 2 5.02073 2.48071 5.02345 3.07276L5.03431 6.82064C5.03431 6.87496 5.04246 6.92656 5.05061 6.97816Z" fill="white"/>
						<path d="M6.0935 1.99707H6.09078C5.49872 1.99707 5.02073 2.47778 5.02345 3.06983L5.03431 6.81771C5.03431 6.87203 5.04246 6.92363 5.05061 6.97523C5.65081 6.24466 6.36508 5.61459 7.16897 5.11215L7.16354 3.0644C7.16354 2.47506 6.68284 1.99707 6.0935 1.99707Z" fill="#4C4C4C"/>
						<path d="M17.493 7.99078C17.1644 7.57797 16.7923 7.20047 16.3822 6.8637C15.3149 5.99191 14.0004 5.41615 12.561 5.2532C12.2921 5.22333 12.0178 5.20703 11.7381 5.20703C11.4584 5.20703 11.2112 5.22061 10.9532 5.25048C9.51925 5.40257 8.2075 5.97019 7.14017 6.8284C6.72193 7.16245 6.34442 7.54267 6.00766 7.95819C5.14401 9.03095 4.57369 10.3481 4.4216 11.7903C4.39444 12.0455 4.38086 12.3036 4.38086 12.5643C4.38086 12.825 4.39444 13.0912 4.42431 13.3492C4.57912 14.7994 5.15759 16.1248 6.0321 17.2002C6.34985 17.5913 6.70563 17.9471 7.09671 18.2649C8.17491 19.1448 9.50567 19.726 10.9641 19.8781C11.2194 19.9052 11.4774 19.9188 11.7408 19.9188C11.9825 19.9188 12.2215 19.9052 12.4551 19.8835C13.9244 19.7423 15.266 19.1638 16.3551 18.2866C16.7407 17.9743 17.0938 17.6266 17.4088 17.2464C18.2969 16.1736 18.8835 14.8456 19.0465 13.3899C19.0763 13.1183 19.0926 12.844 19.0926 12.5643C19.0926 12.3226 19.0791 12.0836 19.0573 11.8473C18.9161 10.397 18.3512 9.07169 17.4903 7.99078H17.493Z" fill="#4C4C4C"/>
						<path d="M11.774 6.52116C11.9886 6.52116 12.214 6.53474 12.4421 6.55918C13.5774 6.68683 14.6501 7.13766 15.5382 7.86279C15.8668 8.13166 16.171 8.43855 16.4399 8.77804C17.1596 9.68242 17.5995 10.7633 17.7082 11.904C17.7272 12.1022 17.738 12.2978 17.738 12.4852C17.738 12.6997 17.7245 12.9251 17.7 13.156C17.5724 14.3048 17.1107 15.3857 16.372 16.2819C16.1194 16.5888 15.8315 16.874 15.5138 17.1266C14.6039 17.8626 13.5122 18.3107 12.3552 18.422C12.157 18.441 11.9614 18.4519 11.774 18.4519C11.5676 18.4519 11.3558 18.441 11.1439 18.4193C9.99514 18.2971 8.91152 17.8463 8.00985 17.1103C7.69481 16.8523 7.40422 16.5617 7.14621 16.2439C6.41565 15.345 5.96481 14.2668 5.8426 13.1234C5.82087 12.9088 5.80729 12.6943 5.80729 12.4852C5.80729 12.2761 5.81816 12.0669 5.83989 11.8551C5.95938 10.7199 6.40478 9.64711 7.12448 8.75088C7.39607 8.41411 7.70568 8.1045 8.04516 7.83292C8.93596 7.11593 10.006 6.67325 11.1358 6.55375C11.3504 6.53203 11.5649 6.51845 11.7713 6.51845M11.7713 5.12793C11.5052 5.12793 11.2444 5.14151 10.9864 5.17138C9.55246 5.32347 8.2407 5.89108 7.17337 6.74929C6.75513 7.08334 6.37762 7.46356 6.04086 7.87909C5.17722 8.95185 4.60689 10.269 4.4548 11.7112C4.42764 11.9664 4.41406 12.2245 4.41406 12.4852C4.41406 12.7459 4.42764 13.0121 4.45752 13.2701C4.61232 14.7203 5.1908 16.0457 6.0653 17.1211C6.38306 17.5122 6.73883 17.868 7.12992 18.1858C8.20811 19.0657 9.53888 19.6469 10.9973 19.799C11.2526 19.8261 11.5106 19.8397 11.774 19.8397C12.0157 19.8397 12.2547 19.8261 12.4883 19.8044C13.9576 19.6632 15.2992 19.0847 16.3883 18.2075C16.7739 17.8952 17.127 17.5475 17.442 17.1673C18.3301 16.0945 18.9167 14.7665 19.0797 13.3108C19.1095 13.0392 19.1258 12.7649 19.1258 12.4852C19.1258 12.2435 19.1123 12.0045 19.0905 11.7682C18.9493 10.3179 18.3844 8.99259 17.5235 7.91168C17.1949 7.49887 16.8228 7.12137 16.4127 6.7846C15.3454 5.91281 14.0309 5.33705 12.5915 5.1741C12.3226 5.14422 12.0483 5.12793 11.7686 5.12793H11.7713Z" fill="#4C4C4C"/>
					</g>
					<defs>
						<clipPath id="clip0_2239_245676">
							<rect width="24" height="24" fill="white" transform="translate(0 0.754883)"/>
						</clipPath>
					</defs>
				</svg>
				<span>熱中症指数</span>
			</h2>
			<!-- /タイトル -->
			<section class="pet-weather__index">
				<!-- 見出し -->
				<h3 class="pet-weather__index--head">
					<p class="is-time">
						<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
							<path d="M5.87784 11.1628C4.59223 11.1337 3.37059 10.5961 2.48061 9.66789C1.59063 8.73967 1.1049 7.49651 1.12984 6.21081C1.10463 4.92494 1.59025 3.68152 2.48025 2.75309C3.37026 1.82466 4.59205 1.28695 5.87784 1.25781C7.16381 1.28668 8.38585 1.82428 9.27608 2.75274C10.1663 3.68121 10.6521 4.92477 10.6268 6.21081C10.6515 7.49661 10.1656 8.73976 9.27542 9.66795C8.38528 10.5961 7.16354 11.1337 5.87784 11.1628ZM5.87784 2.44581C4.90711 2.47485 3.98744 2.88736 3.3202 3.59302C2.65297 4.29868 2.29254 5.23998 2.31784 6.21081C2.29254 7.18165 2.65297 8.12295 3.3202 8.82861C3.98744 9.53427 4.90711 9.94678 5.87784 9.97581C6.84866 9.94678 7.76843 9.5343 8.43582 8.82867C9.10322 8.12304 9.46387 7.18174 9.43884 6.21081C9.46414 5.23981 9.10357 4.29836 8.43612 3.59267C7.76867 2.88698 6.84875 2.47459 5.87784 2.44581Z" fill="#4C4C4C"/>
							<path d="M8.68402 6.72H5.66602V3.125H6.54602V5.84H8.68402V6.72Z" fill="#4C4C4C"/>
						</svg>
						<span>時間</span>
					</p>
					<p class="is-index">
						<svg width="12" height="13" viewBox="0 0 12 13" fill="none">
							<path d="M6.89809 2.90074L7.55294 2.24834C7.74251 2.06001 7.74374 1.75228 7.55418 1.56271C7.36461 1.37315 7.05811 1.37192 6.86854 1.56148L5.66469 2.75918C5.64745 2.77642 5.63268 2.79611 5.61914 2.81581C5.7447 2.8035 5.87148 2.79734 5.9995 2.79734C6.30847 2.79734 6.60881 2.83427 6.89809 2.90197V2.90074Z" fill="white"/>
							<path d="M7.2127 1.41992C7.0896 1.41992 6.96528 1.4667 6.8705 1.56148L5.66664 2.75918C5.64941 2.77642 5.63463 2.79611 5.62109 2.81581C5.74665 2.8035 5.87344 2.79734 6.00145 2.79734C6.31042 2.79734 6.61077 2.83427 6.90004 2.90197L7.5549 2.24957C7.74446 2.06124 7.74569 1.75351 7.55613 1.56394C7.46135 1.46793 7.33702 1.41992 7.2127 1.41992Z" fill="#4C4C4C"/>
							<path d="M5.12454 10.5781L4.44383 11.2625C4.2555 11.4521 4.2555 11.7598 4.44506 11.9482C4.53984 12.0417 4.66294 12.0897 4.78726 12.0897C4.91159 12.0897 5.03591 12.0417 5.13069 11.9469L6.3284 10.7431C6.35425 10.7172 6.3764 10.6877 6.39487 10.6581C6.26439 10.6717 6.13268 10.6778 5.99974 10.6778C5.69816 10.6778 5.40519 10.6434 5.12331 10.5781H5.12454Z" fill="white"/>
							<path d="M5.12454 10.5781L4.44383 11.2625C4.2555 11.4521 4.2555 11.7598 4.44506 11.9482C4.53984 12.0417 4.66294 12.0897 4.78726 12.0897C4.91159 12.0897 5.03591 12.0417 5.13069 11.9469L6.3284 10.7431C6.35425 10.7172 6.3764 10.6877 6.39487 10.6581C6.26439 10.6717 6.13268 10.6778 5.99974 10.6778C5.69816 10.6778 5.40519 10.6434 5.12331 10.5781H5.12454Z" fill="#4C4C4C"/>
							<path d="M10.286 4.66729C10.5531 4.66729 10.7698 4.45064 10.771 4.18353C10.771 3.91518 10.5556 3.69854 10.2872 3.69731L8.58855 3.69238H8.58731C8.56023 3.69238 8.53562 3.69608 8.50977 3.69977C8.83966 3.97304 9.124 4.29924 9.3505 4.66359L10.2848 4.66605H10.286V4.66729Z" fill="white"/>
							<path d="M8.5905 3.69361H8.58927C8.56219 3.69361 8.53757 3.69731 8.51172 3.701C8.84161 3.97427 9.12596 4.30047 9.35245 4.66482L10.2867 4.66729H10.288C10.5551 4.66729 10.7717 4.45064 10.773 4.18353C10.773 3.91518 10.5575 3.69854 10.2892 3.69731L8.5905 3.69238V3.69361Z" fill="#4C4C4C"/>
							<path d="M2.66923 8.83887L1.71033 8.84133C1.44198 8.84133 1.22534 9.0592 1.22657 9.32755C1.22657 9.59466 1.44444 9.81131 1.71156 9.81131H1.71279L3.41148 9.80638C3.44841 9.80638 3.48288 9.80146 3.51734 9.79407C3.18499 9.5245 2.89818 9.20199 2.66923 8.83887Z" fill="white"/>
							<path d="M2.66923 8.83887L1.71033 8.84133C1.44198 8.84133 1.22534 9.0592 1.22657 9.32755C1.22657 9.59466 1.44444 9.81131 1.71156 9.81131H1.71279L3.41148 9.80638C3.44841 9.80638 3.48288 9.80146 3.51734 9.79407C3.18499 9.5245 2.89818 9.20199 2.66923 8.83887Z" fill="#4C4C4C"/>
							<path d="M11.1944 7.62452L9.99668 6.42067C9.97452 6.39851 9.94991 6.37882 9.92406 6.36035C9.93637 6.48345 9.94252 6.609 9.94252 6.73579C9.94252 7.04475 9.90559 7.34633 9.83789 7.6356L10.5075 8.30893C10.6023 8.40371 10.7266 8.45171 10.851 8.45171C10.9753 8.45171 11.0984 8.40494 11.1932 8.31016C11.3827 8.12182 11.3839 7.81409 11.1944 7.62452Z" fill="white"/>
							<path d="M9.92406 6.36035C9.93637 6.48345 9.94252 6.609 9.94252 6.73579C9.94252 7.04475 9.90559 7.34633 9.83789 7.6356L10.5075 8.30893C10.6023 8.40371 10.7266 8.45171 10.851 8.45171C10.9753 8.45171 11.0984 8.40494 11.1932 8.31016C11.3827 8.12182 11.3839 7.81409 11.1944 7.62452L9.99668 6.42067C9.97452 6.39851 9.94991 6.37882 9.92406 6.36035Z" fill="#4C4C4C"/>
							<path d="M2.08041 7.1399C2.06687 7.00696 2.05948 6.87279 2.05948 6.73616C2.05948 6.43581 2.09395 6.14284 2.15796 5.86219L1.49079 5.19871C1.30123 5.01038 0.993493 5.01038 0.805159 5.19994C0.616826 5.38951 0.616826 5.69724 0.80639 5.88558L2.01025 7.08328C2.03117 7.10421 2.05456 7.12267 2.07918 7.13867L2.08041 7.1399Z" fill="white"/>
							<path d="M1.14859 5.05787C1.02427 5.05787 0.899941 5.10588 0.805159 5.20066C0.616826 5.39022 0.616826 5.69796 0.80639 5.88629L2.01025 7.08399C2.03117 7.10492 2.05456 7.12338 2.07918 7.13939C2.06564 7.00645 2.05825 6.87227 2.05825 6.73564C2.05825 6.43529 2.09272 6.14233 2.15673 5.86167L1.48956 5.1982C1.39478 5.10465 1.27168 5.05664 1.14736 5.05664L1.14859 5.05787Z" fill="#4C4C4C"/>
							<path d="M8.0884 10.0759L8.08594 11.0397C8.08594 11.308 8.30135 11.5247 8.5697 11.5259H8.57093C8.83804 11.5259 9.05469 11.3093 9.05592 11.0422L9.06084 9.34346C9.06084 9.3053 9.05592 9.26837 9.0473 9.23145C8.77649 9.56134 8.45276 9.84691 8.08963 10.0746L8.0884 10.0759Z" fill="white"/>
							<path d="M9.04802 9.23268C8.77722 9.56257 8.45348 9.84815 8.09035 10.0759L8.08789 11.0397C8.08789 11.308 8.30331 11.5247 8.57165 11.5259H8.57288C8.83999 11.5259 9.05664 11.3093 9.05787 11.0422L9.06279 9.34346C9.06279 9.3053 9.05787 9.26837 9.04925 9.23145L9.04802 9.23268Z" fill="#4C4C4C"/>
							<path d="M2.95372 4.24068C3.22576 3.90956 3.54949 3.62398 3.91385 3.39626L3.91139 2.46813C3.91139 2.20102 3.69351 1.98438 3.4264 1.98438H3.42517C3.15683 1.98438 2.94018 2.20225 2.94141 2.4706L2.94634 4.16929C2.94634 4.19391 2.95003 4.2173 2.95372 4.24068Z" fill="white"/>
							<path d="M3.4264 1.98242H3.42517C3.15683 1.98242 2.94018 2.2003 2.94141 2.46864L2.94634 4.16734C2.94634 4.19196 2.95003 4.21534 2.95372 4.23873C3.22576 3.90761 3.54949 3.62203 3.91385 3.39431L3.91139 2.46618C3.91139 2.19907 3.69351 1.98242 3.4264 1.98242Z" fill="#4C4C4C"/>
							<path d="M8.59336 4.69921C8.44442 4.51211 8.27578 4.34101 8.08991 4.18837C7.60615 3.79324 7.01037 3.53228 6.35798 3.45843C6.23611 3.44489 6.11179 3.4375 5.985 3.4375C5.85821 3.4375 5.7462 3.44365 5.62926 3.45719C4.97933 3.52613 4.38478 3.78339 3.90102 4.17237C3.71146 4.32378 3.54036 4.49611 3.38772 4.68444C2.99628 5.17066 2.73779 5.76767 2.66885 6.42129C2.65655 6.537 2.65039 6.65394 2.65039 6.77211C2.65039 6.89028 2.65655 7.01091 2.67009 7.12785C2.74025 7.78517 3.00244 8.38587 3.3988 8.87332C3.54282 9.05058 3.70407 9.21183 3.88133 9.35585C4.37001 9.75467 4.97317 10.0181 5.63418 10.087C5.74989 10.0993 5.86683 10.1055 5.98623 10.1055C6.09579 10.1055 6.20411 10.0993 6.30997 10.0895C6.97591 10.0255 7.58399 9.76329 8.0776 9.3657C8.25239 9.22414 8.41241 9.06658 8.5552 8.89425C8.95772 8.40803 9.2236 7.8061 9.29745 7.14632C9.311 7.02322 9.31838 6.8989 9.31838 6.77211C9.31838 6.66256 9.31223 6.55423 9.30238 6.44714C9.23837 5.78982 8.98234 5.18912 8.59213 4.69921H8.59336Z" fill="#4C4C4C"/>
							<path d="M6.00186 4.03284C6.0991 4.03284 6.20127 4.03899 6.30467 4.05007C6.8192 4.10793 7.30542 4.31226 7.70794 4.64092C7.85688 4.76278 7.99475 4.90188 8.11661 5.05575C8.44281 5.46565 8.64222 5.95556 8.69146 6.47256C8.70007 6.56242 8.705 6.65104 8.705 6.73598C8.705 6.83322 8.69884 6.93539 8.68776 7.04002C8.62991 7.56071 8.42065 8.05062 8.08583 8.45683C7.97136 8.59592 7.84088 8.72517 7.69686 8.83965C7.28449 9.17323 6.78966 9.37634 6.26528 9.42681C6.17542 9.43542 6.08679 9.44035 6.00186 9.44035C5.90831 9.44035 5.81229 9.43542 5.71628 9.42558C5.19559 9.37018 4.70445 9.16585 4.29578 8.83227C4.15299 8.71533 4.02128 8.58362 3.90434 8.4396C3.57322 8.03216 3.36888 7.54347 3.31349 7.02525C3.30364 6.928 3.29749 6.83076 3.29749 6.73598C3.29749 6.6412 3.30241 6.54641 3.31226 6.4504C3.36642 5.93587 3.56829 5.44965 3.89449 5.04344C4.01759 4.8908 4.15791 4.75047 4.31178 4.62738C4.71553 4.30241 5.20052 4.10177 5.71259 4.04761C5.80983 4.03776 5.90707 4.03161 6.00063 4.03161M6.00063 3.40137C5.87999 3.40137 5.76182 3.40752 5.64489 3.42106C4.99495 3.48999 4.40041 3.74726 3.91665 4.13624C3.72708 4.28764 3.55598 4.45997 3.40335 4.64831C3.01191 5.13453 2.75341 5.73153 2.68448 6.38516C2.67217 6.50087 2.66602 6.61781 2.66602 6.73598C2.66602 6.85415 2.67217 6.97478 2.68571 7.09172C2.75587 7.74904 3.01806 8.34974 3.41443 8.83719C3.55845 9.01444 3.7197 9.1757 3.89695 9.31972C4.38564 9.71854 4.9888 9.98196 5.64981 10.0509C5.76552 10.0632 5.88246 10.0694 6.00186 10.0694C6.11141 10.0694 6.21973 10.0632 6.32559 10.0534C6.99153 9.98935 7.59961 9.72716 8.09322 9.32956C8.26801 9.18801 8.42804 9.03045 8.57082 8.85811C8.97334 8.37189 9.23922 7.76997 9.31308 7.11018C9.32662 6.98709 9.33401 6.86276 9.33401 6.73598C9.33401 6.62642 9.32785 6.5181 9.318 6.41101C9.25399 5.75369 8.99796 5.15299 8.60775 4.66308C8.45881 4.47598 8.29017 4.30488 8.1043 4.15224C7.62054 3.75711 7.02477 3.49615 6.37237 3.42229C6.25051 3.40875 6.12618 3.40137 5.9994 3.40137H6.00063Z" fill="#4C4C4C"/>
						</svg>
						<span>熱中症指数</span>
					</p>
					<p class="is-temperature">
						<svg width="13" height="13" viewBox="0 0 13 13" fill="none">
							<path d="M8.90375 5.99556V3.75588C8.91609 3.14146 8.68521 2.54705 8.26138 2.10204C7.83755 1.65704 7.25508 1.39748 6.64079 1.37988C6.0265 1.39748 5.44403 1.65704 5.0202 2.10204C4.59636 2.54705 4.36549 3.14146 4.37783 3.75588V6.04116C3.71832 6.75162 3.36434 7.69274 3.39215 8.66172C3.38625 9.12073 3.47082 9.5764 3.64103 10.0027C3.81125 10.429 4.06377 10.8177 4.38418 11.1464C4.70459 11.4751 5.08662 11.7375 5.50844 11.9186C5.93026 12.0997 6.38362 12.1959 6.84263 12.2017C8.67983 12.2017 10.1364 10.6333 10.1364 8.66172C10.1338 8.15496 10.0224 7.65467 9.80981 7.19466C9.59719 6.73466 9.28829 6.32566 8.90399 5.99532L8.90375 5.99556Z" fill="#4C4C4C"/>
							<path d="M8.05335 6.44373V3.75573C8.05939 3.56551 8.02751 3.376 7.95956 3.19823C7.89162 3.02046 7.78897 2.858 7.6576 2.72031C7.52623 2.58261 7.36876 2.47245 7.19438 2.39623C7.02 2.32001 6.8322 2.27927 6.64191 2.27637C6.45164 2.27924 6.26385 2.31994 6.08947 2.39612C5.9151 2.47229 5.75763 2.58241 5.62624 2.72005C5.49485 2.8577 5.39216 3.02012 5.32418 3.19784C5.25619 3.37557 5.22425 3.56505 5.23023 3.75525V6.46725C4.90672 6.73137 4.64921 7.06723 4.47812 7.44821C4.30702 7.82918 4.22705 8.24478 4.24455 8.66205C4.24451 9.35555 4.51694 10.0213 5.00313 10.5158C5.48932 11.0104 6.15034 11.2941 6.84375 11.3059C8.21007 11.3059 9.26319 10.1407 9.26319 8.66205C9.26271 8.22069 9.15176 7.78648 8.94043 7.399C8.72911 7.01152 8.42414 6.68312 8.05335 6.44373Z" fill="#F0F0F0"/>
							<path d="M7.40358 7.13851L7.1571 7.00411V5.07715H6.12654V7.00411L5.90238 7.13851C5.43198 7.40731 5.14062 7.96747 5.14062 8.66203C5.146 9.10816 5.32398 9.53487 5.63722 9.85259C5.95047 10.1703 6.37461 10.3543 6.82062 10.366C7.69446 10.366 8.34415 9.62659 8.34415 8.66203C8.33928 8.34682 8.24924 8.03879 8.08358 7.77059C7.91791 7.50238 7.68278 7.28397 7.4031 7.13851H7.40358Z" fill="#4C4C4C"/>
							</svg>
						<span>気温</span>
					</p>
					<p class="is-humidity">
						<svg width="13" height="13" viewBox="0 0 13 13" fill="none">
							<path d="M11.1479 5.00818C11.1012 4.99097 11.0515 4.98317 11.0017 4.98523C10.952 4.98728 10.9031 4.99915 10.8579 5.02015C10.8128 5.04115 10.7722 5.07088 10.7386 5.10761C10.7049 5.14434 10.6789 5.18735 10.6619 5.23418C10.5354 5.50378 10.3436 5.73752 10.1039 5.91418C9.85612 6.09392 9.56161 6.19811 9.25592 6.21418C9.11092 6.21418 8.94992 6.20418 8.76592 6.19118C8.53492 6.17518 8.27392 6.15718 7.96592 6.15718H7.95592C7.87492 6.15718 7.79192 6.15718 7.70992 6.16618C7.6673 6.16843 7.62537 6.1779 7.58592 6.19418C7.38592 5.72318 7.16592 5.25918 6.94992 4.80718H6.95992C7.26692 4.79818 7.54792 4.80718 7.79492 4.82318C7.96492 4.83118 8.12692 4.83918 8.28492 4.83918H8.37592C8.85158 4.81691 9.30263 4.62126 9.64392 4.28918C10.002 3.95632 10.2791 3.54581 10.4539 3.08918C10.4701 3.0415 10.4766 2.99108 10.4732 2.94084C10.4697 2.89061 10.4563 2.84157 10.4337 2.79657C10.4111 2.75157 10.3798 2.71151 10.3415 2.67871C10.3033 2.64592 10.259 2.62105 10.2111 2.60554C10.1632 2.59004 10.1127 2.58421 10.0625 2.5884C10.0123 2.59258 9.96346 2.6067 9.91878 2.62992C9.8741 2.65315 9.83449 2.68503 9.80224 2.7237C9.76999 2.76237 9.74574 2.80706 9.73092 2.85518C9.59284 3.19122 9.38334 3.4932 9.11692 3.74018C8.91104 3.94217 8.63969 4.06384 8.35192 4.08318C8.19492 4.08318 8.02392 4.08318 7.82592 4.06918C7.56392 4.05718 7.26592 4.04318 6.92592 4.05318H6.92792C6.87092 4.05318 6.81292 4.05918 6.74292 4.06518C6.69784 4.06902 6.65382 4.08087 6.61292 4.10018C6.57192 4.01218 6.53192 3.92418 6.49292 3.83718C6.21056 2.96571 5.8159 2.13472 5.31892 1.36518C5.25549 1.27372 5.17325 1.19687 5.0777 1.13978C4.98216 1.0827 4.87551 1.04669 4.76492 1.03418C4.72852 1.03406 4.69225 1.03843 4.65692 1.04718C4.02292 1.20518 3.79692 2.12718 3.58292 2.65318C3.23492 3.50718 2.87792 4.35318 2.47392 5.18718C1.7729 6.24762 1.30807 7.44637 1.11092 8.70218C1.07916 9.19283 1.14982 9.68472 1.31841 10.1466C1.48699 10.6085 1.7498 11.0302 2.09015 11.3851C2.43051 11.7399 2.84095 12.02 3.2954 12.2077C3.74985 12.3954 4.23837 12.4865 4.72992 12.4752C4.80725 12.4752 4.88558 12.4732 4.96492 12.4692C5.81638 12.4155 6.62018 12.0576 7.22966 11.4606C7.83914 10.8636 8.21367 10.0674 8.28492 9.21718C8.28956 8.43293 8.14815 7.65467 7.86792 6.92218H7.96792C8.24992 6.92218 8.49692 6.94018 8.71392 6.95518C8.90092 6.96818 9.07692 6.98018 9.24592 6.98018H9.26692C9.73328 6.96222 10.1834 6.80438 10.5589 6.52718H10.5639C10.9208 6.26548 11.2006 5.91244 11.3739 5.50518C11.4084 5.41036 11.4039 5.30573 11.3613 5.21424C11.3188 5.12276 11.2417 5.05189 11.1469 5.01718M4.28992 6.63418C4.24324 6.65181 4.19354 6.66006 4.14367 6.65844C4.0938 6.65682 4.04474 6.64536 3.99931 6.62474C3.95388 6.60411 3.91297 6.57472 3.87892 6.53824C3.84487 6.50177 3.81837 6.45893 3.80092 6.41218C3.76392 6.31218 3.74692 6.21218 3.89492 5.89418C4.01232 5.65166 4.15476 5.42208 4.31992 5.20918L4.32892 5.19818C4.75938 4.68372 5.34797 4.32614 6.00292 4.18118C6.10792 4.41318 6.21792 4.64618 6.33192 4.88118C5.9278 4.93954 5.54705 5.1063 5.23011 5.36372C4.91317 5.62114 4.6719 5.95962 4.53192 6.34318C4.51946 6.40668 4.49096 6.46593 4.44913 6.5153C4.40729 6.56466 4.35351 6.60249 4.29292 6.62518M4.79792 8.53418C4.85429 8.09511 4.99885 7.67197 5.22292 7.29018C5.41526 6.99555 5.67218 6.7486 5.97418 6.56806C6.27618 6.38751 6.61534 6.27812 6.96592 6.24818C7.06592 6.48918 7.16592 6.73018 7.25892 6.97118C6.32692 7.09918 6.02492 7.42518 5.87892 7.67118C5.71171 7.95655 5.60166 8.27175 5.55492 8.59918C5.54667 8.6938 5.50329 8.78189 5.43333 8.84612C5.36336 8.91034 5.27189 8.94604 5.17692 8.94618H5.14392C5.09412 8.9419 5.04566 8.92785 5.00131 8.90481C4.95696 8.88178 4.91759 8.85023 4.88545 8.81196C4.85331 8.77369 4.82904 8.72945 4.81402 8.68179C4.799 8.63412 4.79352 8.58396 4.79792 8.53418Z" fill="#4C4C4C"/>
						</svg>
						<span>湿度</span>
					</p>
				</h3>
				<!-- /見出し -->
				<!-- リスト -->
				<div class="pet-weather__index--inner">
					<section v-for="(item, index) in weatherData" :key="`pet-heatstroke-index-date${index}`">
						<h4 class="pet-weather__index--date">{{ item[0].date }}</h4>
						<ul class="pet-weather__index--list">
							<li v-for="(data, indexTime) in item" :key="`pet-heatstroke-index-time${indexTime}`">
								<div v-if="data.wbgt_level !== 'wbgt_level0'" class="pet-weather__index--item">
									<p class="is-time">
										<span>{{ data.time }}</span>
									</p>
									<p class="is-index">
										<i :class="`sprite ${data.wbgt_level}`" />
									</p>
									<div class="pet-weather__index--item-inner">
										<p class="is-temperature">
											<i :class="`sprite ${data.temperature_level}`" />
											<span>{{ data.temperature }}℃</span>
										</p>
										<p class="is-humidity">
											<i :class="`sprite ${data.humidity_level}`" />
											<span>{{ data.humidity }}%</span>
										</p>
										<p
											:class="[
												'is-comment',
												{ 'is-open': data.is_heatstroke_comment_open }
											]"
											@click="onToggleComment(index, indexTime, data, 'heatstroke')"
										>
											<span v-html="data.wbgt_comment"></span>
											<svg class="close" width="18" height="12" viewBox="0 0 18 12" fill="none">
												<rect x="0.726562" y="0.5" width="17" height="11" rx="4" fill="#999999"/>
												<path d="M5.77734 7.72461L9.21822 4.27447L12.6776 7.72461" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
											</svg>
											<svg class="open" width="17" height="11" viewBox="0 0 17 11" fill="none">
												<rect width="17" height="11" rx="4" fill="#999999"/>
												<path d="M11.9512 3.77441L8.51029 7.22456L5.05089 3.77441" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
											</svg>
										</p>
									</div>
								</div>
								<p v-else class="pet-weather__nodata">データが取得できません</p>
								<p v-if="arraySolarTime.length > 0 && arraySolarTime[index].sunrise_key === `${item[0].date}_${data.time}`" class="pet-weather__solartime">
									<span class="is-time">{{ arraySolarTime[index].sunrise }}</span>
									<span class="is-text"><img src="~@/assets/img/pet/icon_sunrise.png">日の出</span>
								</p>
								<p v-if="arraySolarTime.length > 0 && arraySolarTime[index].sunset_key === `${item[0].date}_${data.time}`" class="pet-weather__solartime">
									<span class="is-time">{{ arraySolarTime[index].sunset }}</span>
									<span class="is-text"><img src="~@/assets/img/pet/icon_sunset.png">日の入</span>
								</p>
							</li>
						</ul>
					</section>
				</div>
				<!-- /リスト -->
			</section>
		</section>
		<!-- /熱中症指数-->
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_PET_WEATHER_DATA } from '@/store/modules/pet/mutation-types'
import { SET_SOLAR_TIME } from '@/store/modules/weatherForecast/mutation-types'

// Compornents
import WebviewRedrawProgress from '@/components/Molecules/WebviewRedrawProgress'

// ライブラリ
import moment from 'moment'
moment.locale('ja')

export default {
	name: 'PetIndexTop',
	components: {
		WebviewRedrawProgress
	},
	data () {
		return {
			isLoading: false,
			weatherData: [],
			arraySolarTime: []
		}
	},
	props: {
	},
	created () {
	},
	mounted () {
		// データの取得
		this.getWeatherData()
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userId', 'userToken', 'userData']),
		...mapGetters('pet', ['petWeatherData'])
	},
	methods: {
		// map Vuex actions
		...mapActions('pet', [SET_PET_WEATHER_DATA]),
		...mapActions('weatherForecast', [SET_SOLAR_TIME]),

		// 必要なデータをAPIリクエストする処理
		getWeatherData () {
			const today = moment()
			const tomorrow = moment().add(1, 'days')
			this.isLoading = true

			// ペット指数取得API
			this.SET_PET_WEATHER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			}).then(res => {
				const cityCode = this.userData.city_code

				// 今日の日の出・日の入り
				const SET_SOLAR_TIME_TODAY = this.SET_SOLAR_TIME({
					user_id: this.userId,
					user_token: this.userToken,
					year: today.year(),
					month: today.month() + 1,
					day: today.date(),
					city_code: cityCode
				})

				// 明日の日の出・日の入り
				const SET_SOLAR_TIME_TOMORROW = this.SET_SOLAR_TIME({
					user_id: this.userId,
					user_token: this.userToken,
					year: tomorrow.year(),
					month: tomorrow.month() + 1,
					day: tomorrow.date(),
					city_code: cityCode
				})

				// 日の出・日の入りのリクエスト
				return Promise.all([SET_SOLAR_TIME_TODAY, SET_SOLAR_TIME_TOMORROW])
			}).then(res => {
				console.log(res)
				console.log(this.petWeatherData)
				// 日の出日の入りのデータを整形
				const todayData = res[0].data
				const todaySolarTime = {
					'sunrise': todayData.sunrise,
					'sunrise_key': `${today.format('D(ddd)')}_${todayData.sunrise.split(':')[0]}`,
					'sunset': todayData.sunset,
					'sunset_key': `${today.format('D(ddd)')}_${todayData.sunset.split(':')[0]}`
				}
				const tomorrowData = res[1].data
				const tomorrowSolarTime = {
					'sunrise': tomorrowData.sunrise,
					'sunrise_key': `${tomorrow.format('D(ddd)')}_${tomorrowData.sunrise.split(':')[0]}`,
					'sunset': tomorrowData.sunset,
					'sunset_key': `${tomorrow.format('D(ddd)')}_${tomorrowData.sunset.split(':')[0]}`
				}
				this.arraySolarTime = [todaySolarTime, tomorrowSolarTime]
				console.log(this.arraySolarTime)

				// データの初期化
				this.initData()
			}).catch(error => {
				// NOTE: エラー処理
				console.log('Error: ', error)

				// エラーでも表示するため、データの初期化
				this.initData()
			}).finally(() => {
				this.isLoading = false
			})
		},

		// データの初期化
		initData () {
			const getLevelClass = (type, level) => {
				let className = ''
				if (type === 'road_temp_prediction_level') {
					switch (level) {
						case 1:
							className = 'ng'
							break
						case 2:
							className = 'well'
							break
						case 3:
							className = 'ok'
							break
						case 4:
							className = 'more-ok'
							break
						case 5:	// APIレスポンスでは5がないが、念のため
							className = 'more-ok'
							break
					}
				} else if (type === 'rain_fall_level') {
					switch (level) {
						case 1:
							className = 'more-ok'
							break
						case 2:
							className = 'well'
							break
						case 3:
							className = 'ng'
							break
						case 4:
							className = 'ng'
							break
						case 5:
							className = 'ng'
							break
					}
				} else if (type === 'temperature_level' || type === 'humidity_level') {
					switch (level) {
						case 1:
							className = 'ng'
							break
						case 2:
							className = 'well'
							break
						case 3:
							className = 'ok'
							break
						case 4:
							className = 'ok'	// APIレスポンスでは5がないが、念のため
							break
						case 5:
							className = 'ok'	// APIレスポンスでは5がないが、念のため
							break
					}
				} else if (type === 'walking_index' || type === 'wbgt') {
					className = `${type}_level${level}`
				} else {
					switch (level) {
						case 1:
							className = 'more-ok'
							break
						case 2:
							className = 'ok'
							break
						case 3:
							className = 'well'
							break
						case 4:
							className = 'ng'
							break
						case 5:
							className = 'ng'
							break
					}
				}
				return className
			}

			const getWbgtComment = level => {
				let comment = ''
				switch (level) {
					case 1:
						comment = '外出禁止。冷房を強めに設定して25℃以下になるようにしましょう。<br>水分補給しやすいように複数の飲み水を用意しましょう。<br>フレンチブルドッグやパグなど短頭種は暑さが苦手なので特に体調管理に注意しましょう。'
						break
					case 2:
						comment = '外出は極力控え、室内の冷房はなるべく25℃以下の設定にしましょう。<br>水分補給しやすいように複数の飲み水を用意しましょう。<br>フレンチブルドッグやパグなど短頭種は暑さが苦手なので特に体調管理に注意しましょう。'
						break
					case 3:
						comment = '外出時はアスファルトの上を避けましょう。室内では冷房を活用しましょう。<br>フレンチブルドッグやパグなど短頭種は暑さが苦手なので特に体調管理に注意しましょう。'
						break
					case 4:
						comment = '外出しても動き回らずに短時間にしましょう。'
						break
					case 5:
						comment = '安心して外出もできるでしょう。'
						break
				}
				return comment
			}

			const today = moment().format('D(ddd)')
			const tomorrow = moment().add(1, 'days').format('D(ddd)')
			let data = []
			if (this.petWeatherData) {
				data = this.petWeatherData.records.map(record => {
					return {
						date: moment.unix(record.date).format('D(ddd)'),
						time: moment.unix(record.date).format('H'),
						rain_fall: record.rain_fall,
						rain_fall_level: getLevelClass('rain_fall_level', record.rain_fall_level),
						road_temp_prediction: record.road_temp_prediction,
						road_temp_prediction_level: getLevelClass('road_temp_prediction_level', record.road_temp_prediction_level),
						walking_index: getLevelClass('walking_index', record.walking_index ? record.walking_index : 0),
						wbgt_level: getLevelClass('wbgt', record.wbgt_level ? record.wbgt_level : 0),
						wind_velocity: record.wind_velocity,
						wind_velocity_level: getLevelClass('wind_velocity_level', record.wind_velocity_level),
						temperature: record.temperature,
						humidity: record.humidity,
						temperature_level: getLevelClass('temperature_level', record.temperature_level),
						humidity_level: getLevelClass('humidity_level', record.humidity_level),
						walking_comment: record.comment,
						wbgt_comment: getWbgtComment(record.wbgt_level),
						is_walking_comment_open: false,
						is_heatstroke_comment_open: false
					}
				})
			} else {
				// NOTE: SET_PET_WEATHER_DATAが失敗したケース
				data = [
					{ date: today, walking_index: 'walking_index_level0', wbgt_level: 'wbgt_level0' },
					{ date: tomorrow, walking_index: 'walking_index_level0', wbgt_level: 'wbgt_level0' }
				]
			}

			const todayData = data.filter(record => record.date === today)
			const tommorrowData = data.filter(record => record.date === tomorrow)
			this.weatherData.push(todayData)
			this.weatherData.push(tommorrowData)
		},

		// コメントの開閉
		onToggleComment (i, j, data, type) {
			this.$set(this.weatherData[i][j], `is_${type}_comment_open`, !data[`is_${type}_comment_open`])
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

$color-background-date: #CCC;
$color-highlight: #FDF0DF;

$font-size-11: 0.6875rem;

$spacing-1: 0.0625rem;
$spacing-12: 0.75rem;
$spacing-20_5: 1.28125rem;
$spacing-32: 1.9375rem;
$spacing-110: 6.875rem;

.pet-weather {
	padding: $spacing-16 $spacing-10;
	background-color: $background-primary;
	font-family: $lp-family-secondary;
	color: $text-primary;

	// mplusのジャギー対策
	p, em, span, h2, h3, h4 { transform: rotate(0.05deg); }

	&__inner + &__inner { margin-top: $spacing-32; }

	&__title {
		display: flex;
		align-items: center;
		margin: 0;
		font-family: $lp-family-secondary;
		font-weight: normal;

		span { margin-left: $spacing-4; }
	}

	&__nodata {
		padding: $spacing-32 0;
		margin: 0;
		font-family: $lp-family-primary;
		font-size: $font-size-14;
		text-align: center;
		border-bottom: $spacing-1 solid $line-primary;
	}

	&__solartime {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 0;
		padding: $spacing-4 0;
		background-color: $background-secondary;
		font-family: $lp-family-secondary;
		font-size: $font-size-10;

		& > .is-time {
			position: absolute;
			top: 50%;
			left: 0;
			transform: translateY(-50%);
			width: 11.8981%;
			text-align: center;
		}

		& > .is-text {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			line-height: $line-height-1;

			img { width: 26px; }
		}
	}

	&__index {
		position: relative;
		margin-top: $spacing-8;
		border-radius: $spacing-10;
		border: $spacing-1 solid $line-primary;

		&--head {
			display: flex;
			align-items: center;
			margin: 0 0 -#{$spacing-1};
			padding: $spacing-4 0;
			background-color: $background-secondary;
			border-bottom: $spacing-1 solid $line-primary;
			font-family: $lp-family-secondary;
			font-weight: normal;
			font-size: $font-size-10;
			box-sizing: border-box;
			border-radius: $spacing-10 $spacing-10 0 0;

			& > p {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 0;
				box-sizing: border-box;
				border-right: $spacing-1 solid $line-primary;
				line-height: $line-height-1;

				&:last-child { border-right: none; }
				&.is-time { width: 12.4646%; }
				&.is-index { width: 30.8782%; }
				&.is-road-surface-temperature { width: 18.9802%; }
				&.is-precipitation { width: 18.9802%; }
				&.is-wind { width: 18.6969%; }
				&.is-temperature { width: 28.6119%; }
				&.is-humidity { width: 28.3287%; }
			}
		}

		&--inner {
			position: relative;
			height: 379px;
			overflow-y: scroll;
			overflow-x: hidden;
		}

		&--date {
			position: sticky;
			top: 0;
			left: 0;
			width: 11.8981%;
			margin: 0 0 -#{$spacing-20_5};
			padding: $spacing-2 $spacing-4;
			background-color: $color-background-date;
			font-family: $lp-family-secondary;
			font-size: $font-size-11;
			font-weight: normal;
			box-sizing: border-box;
			z-index: 10;

			@media (max-width: (360px)) {
				font-size: $font-size-10;
			}
		}

		&--list {
			position: relative;
			margin: 0;
			padding: 0;
			list-style: none;
		}

		&--item {
			display: flex;
			padding: $spacing-6 0;

			p {
				display: flex;
				align-items: center;
				flex-direction: column;
				margin: 0;
				box-sizing: border-box;
				font-size: $font-size-10;

				&.is-time {
					width: 11.8981%;
					padding: $spacing-20 0 0 $spacing-8;
					font-size: $spacing-14;
				}

				&.is-index {
					align-items: stretch;
					width: 31.1615%;

					& > i {
						margin: 0 auto;

						@media (max-width: (360px)) {
							transform: scale(.9);
							transform-origin: center center;
						}
					}
				}
			}

			&-inner {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				width: 57.2238%;

				& > p {
					border-left: $spacing-1 solid $line-primary;
					box-sizing: border-box;

					&:last-child { border-left: none; }

					&.is-road-surface-temperature,
					&.is-precipitation,
					&.is-wind {
						width: 33.3333%;
					}

					&.is-temperature,
					&.is-humidity {
						width: 50%;
					}

					&.is-road-surface-temperature,
					&.is-precipitation,
					&.is-wind,
					&.is-temperature,
					&.is-humidity {
						padding: 0 $spacing-8;

						& > span {
							width: 100%;
							margin-top: $spacing-2;
							background-color: $color-highlight;
							border-radius: $spacing-4;
							text-align: center;
						}
					}

					&.is-comment {
						position: relative;
						align-items: flex-start;
						flex-wrap: nowrap;
						width: 100%;
						padding: $spacing-6 $spacing-32 $spacing-6 0;

						& > span {
							position: relative;
							display: block;
							width: 100%;
							max-height: $spacing-14;	// 1行分の高さ
							overflow: hidden;
							transition: max-height .2s ease-out;
							transform: none;	// transformしているとiPhoneのoverflowが効かないため

							&::before {
								content: '…';
								position: absolute;
								top: 0;
								right: 0;
								width: $spacing-10;
								height: 100%;
								background: $background-primary;
							}
						}

						& > svg {
							position: absolute;
							top: 50%;
							right: $spacing-12;
							transform: translateY(-50%);
						}

						& > svg.open { display: block; }
						& > svg.close { display: none; }

						&.is-open {
							& > span {
								max-height: $spacing-110;	// 十分な高さを確保

								&::before { content: none; }
							}

							& > svg.open { display: none; }
							& > svg.close { display: block; }
						}
					}
				}
			}
		}
	}
}

// スプライト
.sprite {
	background-image: url(~@/assets/img/pet/sprite_pet_weather.png);
	background-size: (195px / 2) (1481px / 2);
	background-repeat: no-repeat;
	display: block;

	&.more-ok {
		width: (56px / 2);
		height: (44px / 2);
		background-position: (-5px / 2) (-5px / 2);
	}

	&.ng {
		width: (56px / 2);
		height: (44px / 2);
		background-position: (-5px / 2) (-59px / 2);
	}

	&.ok {
		width: (56px / 2);
		height: (44px / 2);
		background-position: (-5px / 2) (-113px / 2);
	}

	&.walking_index_level1 {
		width: (185px / 2);
		height: (117px / 2);
		background-position: (-5px / 2) (-167px / 2);
	}

	&.walking_index_level2 {
		width: (185px / 2);
		height: (117px / 2);
		background-position: (-5px / 2) (-294px / 2);
	}

	&.walking_index_level3 {
		width: (185px / 2);
		height: (117px / 2);
		background-position: (-5px / 2) (-421px / 2);
	}

	&.walking_index_level4 {
		width: (185px / 2);
		height: (117px / 2);
		background-position: (-5px / 2) (-548px / 2);
	}

	&.walking_index_level5 {
		width: (185px / 2);
		height: (117px / 2);
		background-position: (-5px / 2) (-675px / 2);
	}

	&.wbgt_level1 {
		width: (184px / 2);
		height: (116px / 2);
		background-position: (-5px / 2) (-802px / 2);
	}

	&.wbgt_level2 {
		width: (184px / 2);
		height: (116px / 2);
		background-position: (-5px / 2) (-928px / 2);
	}

	&.wbgt_level3 {
		width: (184px / 2);
		height: (116px / 2);
		background-position: (-5px / 2) (-1054px / 2);
	}

	&.wbgt_level4 {
		width: (184px / 2);
		height: (116px / 2);
		background-position: (-5px / 2) (-1180px / 2);
	}

	&.wbgt_level5 {
		width: (184px / 2);
		height: (116px / 2);
		background-position: (-5px / 2) (-1306px / 2);
	}

	&.well {
		width: (56px / 2);
		height: (44px / 2);
		background-position: (-5px / 2) (-1432px / 2);
	}
}

</style>
